import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const TrustDevice = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    const verified = searchParams.get('verified');
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error === 'device_trust_expired') {
      setStatus('error');
      return;
    }

    if (verified === 'true' && token) {
      localStorage.setItem('token', token);
      // Get user info from token
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        localStorage.setItem('user', JSON.stringify({
            id: payload.id,
            email: payload.email,
            role: payload.role,
            full_name: payload.email, // JWT doesn't carry full_name, use email as fallback
          }));
      } catch {}
      setStatus('success');
      setTimeout(() => navigate('/'), 2000);
      return;
    }

    setStatus('waiting');
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#f9fafb',
    }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 24px' }}>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <span style={{ fontSize: 48 }}>🛡️</span>
          <h1 style={{ margin: '8px 0 4px', fontSize: 28, fontWeight: 700, color: '#111827' }}>
            RegShield
          </h1>
        </div>

        <div style={{
          background: 'white', borderRadius: 12, padding: '32px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #f0f0f0',
          textAlign: 'center',
        }}>
          {status === 'loading' && (
            <>
              <p style={{ fontSize: 32, margin: '0 0 16px' }}>⏳</p>
              <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
                Verifying device…
              </h2>
            </>
          )}

          {status === 'waiting' && (
            <>
              <p style={{ fontSize: 32, margin: '0 0 16px' }}>📧</p>
              <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#111827' }}>
                Check your email
              </h2>
              <p style={{ margin: '0 0 20px', fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
                A new device was detected. We've sent you an email with a link to trust this device.
                The link expires in <strong>15 minutes</strong>.
              </p>
              <p style={{ margin: '0 0 20px', fontSize: 12, color: '#9ca3af' }}>
                Once you click the link in your email, you'll be signed in automatically.
              </p>
              <button
                onClick={() => navigate('/login')}
                style={{
                  background: 'white', color: '#6b7280',
                  border: '1px solid #e5e7eb', borderRadius: 8,
                  padding: '10px 20px', fontSize: 13, cursor: 'pointer',
                }}
              >
                ← Back to login
              </button>
            </>
          )}

          {status === 'success' && (
            <>
              <p style={{ fontSize: 32, margin: '0 0 16px' }}>✅</p>
              <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#166534' }}>
                Device trusted
              </h2>
              <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>
                Redirecting to dashboard…
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <p style={{ fontSize: 32, margin: '0 0 16px' }}>❌</p>
              <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 600, color: '#991b1b' }}>
                Link expired
              </h2>
              <p style={{ margin: '0 0 20px', fontSize: 13, color: '#6b7280' }}>
                The device trust link has expired. Please log in again.
              </p>
              <button
                onClick={() => navigate('/login')}
                style={{
                  background: '#1e3a5f', color: 'white',
                  border: 'none', borderRadius: 8,
                  padding: '10px 20px', fontSize: 13,
                  fontWeight: 700, cursor: 'pointer',
                }}
              >
                Back to login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrustDevice;